import { useId } from 'react';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Input } from '@/components/shared/shadcn-ui/input';
import { Label } from '@/components/shared/shadcn-ui/label';
import { Button } from '@/components/shared/shadcn-ui/button';

export interface SupplierFormData {
  name: string;
  emails: string[];
}

export const isSupplierFormValid = (formData: SupplierFormData) =>
  formData.name.length > 0 &&
  formData.emails.length > 0 &&
  formData.emails.every((email) => email.length > 0);

interface SupplierFormFieldsProps {
  formData: SupplierFormData;
  setFormData: (formData: SupplierFormData) => void;
}

export const SupplierFormFields = ({
  formData,
  setFormData,
}: SupplierFormFieldsProps) => {
  const { t } = useTranslation();
  const uid = useId();

  return (
    <div className="flex flex-col gap-4 p-2">
      <div className="flex flex-col gap-2">
        <Label htmlFor={uid + '-name'}>{t('common.name')}</Label>
        <Input
          required
          id={uid + '-name'}
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        />
      </div>
      <div className="flex flex-col gap-2">
        <Label>{t('suppliers.emails')}</Label>
        {formData.emails.map((email, index) => (
          <div key={index} className="flex items-center gap-2">
            <Input
              required
              type="email"
              value={email}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  emails: formData.emails.map((current, i) =>
                    i === index ? e.target.value : current,
                  ),
                })
              }
            />
            {formData.emails.length > 1 && (
              <Button
                type="button"
                variant="ghost"
                className="p-2"
                onClick={() =>
                  setFormData({
                    ...formData,
                    emails: formData.emails.filter((_, i) => i !== index),
                  })
                }
              >
                <X className="w-4 h-4" />
              </Button>
            )}
          </div>
        ))}
        <Button
          type="button"
          variant="outline"
          className="self-start"
          onClick={() =>
            setFormData({ ...formData, emails: [...formData.emails, ''] })
          }
        >
          {t('suppliers.add-email')}
        </Button>
      </div>
    </div>
  );
};
